var Handlebars = require("/home/admin/gitlab_code/assets/enhancer/enhancer-forum-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), alias4=helpers.blockHelperMissing;

  return "<li>\n	<a href=\""
    + alias2(alias1((depth0 != null ? depth0.projectName : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? depth0.uid : depth0), depth0))
    + "/topic\" target=\"_blank\">\n		<img src=\""
    + alias2(alias1((depth0 != null ? depth0.avatar : depth0), depth0))
    + "\" alt=\"avatar\">\n	</a>\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.adStr : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	<div class=\"list-item\">\n		<div class=\"topic-title\" title=\""
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.topText : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "			<a class=\"title-text elli "
    + ((stack1 = alias4.call(depth0,alias1((depth0 != null ? depth0.del : depth0), depth0),{"name":"del","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link_url : depth0), depth0))
    + "\" target=\"_blank\">"
    + alias2(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "</a>\n"
    + ((stack1 = helpers.each.call(alias3,(depth0 != null ? depth0.tags : depth0),{"name":"each","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "			"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.resolved : depth0),{"name":"if","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.fixed : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n\n			<span class=\"fr reply-num\"><i class=\"talk icon\"></i> <span>"
    + alias2(alias1((depth0 != null ? depth0.replyCount : depth0), depth0))
    + "</span></span>\n		</div>\n		<div class=\"title-user\">\n			<a class=\"user-link\" href=\""
    + alias2(alias1((depth0 != null ? depth0.projectName : depth0), depth0))
    + "/"
    + alias2(alias1((depth0 != null ? depth0.uid : depth0), depth0))
    + "/topic\" target=\"_blank\">\n				<span>"
    + alias2(alias1((depth0 != null ? depth0.nickname : depth0), depth0))
    + "</span>\n			</a>\n			"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.pv : depth0),{"name":"if","hash":{},"fn":container.program(14, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.npv : depth0),{"name":"if","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			<span class=\"create-time\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.create : depth0)) != null ? stack1.tip : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.create : depth0)) != null ? stack1.text : stack1), depth0))
    + "</span>\n			"
    + ((stack1 = alias4.call(depth0,alias1((depth0 != null ? depth0.showDelete : depth0), depth0),{"name":"showDelete","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n			<span class=\"fr fs12\" title=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.update : depth0)) != null ? stack1.tip : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.update : depth0)) != null ? stack1.text : stack1), depth0))
    + "</span>\n		</div>\n	</div>\n</li>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "		<div class=\"forum-role\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.adStr : depth0), depth0))
    + "</div>\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "				<a class=\"ui label transition visible top title-text title-tag\"><span class=\"top-arrow\">↑</span>"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.topText : depth0), depth0))
    + "</a>\n";
},"6":function(container,depth0,helpers,partials,data) {
    return "delete-line";
},"8":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "				<a class=\"ui label transition visible "
    + alias2(alias1((depth0 != null ? depth0.type : depth0), depth0))
    + " title-text title-tag\">"
    + alias2(alias1((depth0 != null ? depth0.text : depth0), depth0))
    + "</a>\n";
},"10":function(container,depth0,helpers,partials,data) {
    return " <span style=\"color: #00C957;\"><i style=\"margin-right: 2px;\" class=\"check icon\"></i><span >"
    + container.escapeExpression(require("/home/admin/gitlab_code/assets/enhancer/enhancer-forum-assets/src/pages/myTopic/i18n/index.js").call(depth0 != null ? depth0 : (container.nullContext || {}),"resolved",{"name":"i18n","hash":{},"data":data}))
    + "</span></span>";
},"12":function(container,depth0,helpers,partials,data) {
    return " <span style=\"color: #00C957;\"><i style=\"margin-right: 2px;\" class=\"check icon\"></i><span >"
    + container.escapeExpression(require("/home/admin/gitlab_code/assets/enhancer/enhancer-forum-assets/src/pages/myTopic/i18n/index.js").call(depth0 != null ? depth0 : (container.nullContext || {}),"fixed",{"name":"i18n","hash":{},"data":data}))
    + "</span></span>";
},"14":function(container,depth0,helpers,partials,data) {
    return "<span>pv: "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.pv : depth0), depth0))
    + "</span>";
},"16":function(container,depth0,helpers,partials,data) {
    return " <span>npv: "
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.npv : depth0), depth0))
    + "</span> ";
},"18":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "<i data-plate=\""
    + alias2(alias1((depth0 != null ? depth0.plate : depth0), depth0))
    + "\" data-tid=\""
    + alias2(alias1((depth0 != null ? depth0._id : depth0), depth0))
    + "\" class=\"trash outline icon remove-list-item\"></i>";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? depth0.data : depth0), depth0),{"name":"data","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/app/topicList.html
// module id = 17
// module chunks = 0